import dynamic from 'next/dynamic';

import {
  MainClosingSaleSection,
  MainInstagramReviewSection,
  MainLineBannerSection,
  MainMdChoicesSection,
  MainRandomCollectionSection,
  MainRecipesSection,
  MainSection,
  MainSectionBanner,
  MainSpecialDealsSection,
  MainTodayRecommendationSection,
  MainRandomCollectionArticleSection,
  MainGroupCollectionCircleSection,
  MainSectionBannerCarousel,
} from '../../interfaces/MainSection.interface';

import { isPC } from '../../../../util/window/getDevice';

const dynamicImportOption = { ssr: false };

const MainBanner = dynamic(
  () => (isPC ? import('../pc/banner/MainBanner') : import('../m/banner/MainBanner')),
  dynamicImportOption,
);

const MainBannerCarousel = dynamic(
  () => (isPC ? import('../pc/carousel-banner/MainBannerCarousel') : import('../m/carousel-banner/MainBannerCarousel')),
  dynamicImportOption,
);

const TodayRecommendProducts = dynamic(
  () =>
    isPC
      ? import('../pc/today-recommendation/TodayRecommendProducts')
      : import('../m/today-recommendation/TodayRecommendProducts'),
  dynamicImportOption,
);

const RandomCollection = dynamic(
  () =>
    isPC
      ? import('../pc/random-collection/RandomCollection')
      : import('../m/random-collection/RandomCollectionSection'),
  dynamicImportOption,
);

const LineBanner = dynamic(
  () => (isPC ? import('../pc/line-banner/MainLineBanner') : import('../m/line-banner/MainLineBanner')),
  dynamicImportOption,
);

const SpecialDeals = dynamic(
  () => (isPC ? import('../pc/special-deals/SpecialDeals') : import('../m/special-deals/SpecialDeals')),
  dynamicImportOption,
);

const MdChoices = dynamic(
  () => (isPC ? import('../pc/md-choices/MdChoicesContainer') : import('../m/md-choices/MdChoicesContainer')),
  dynamicImportOption,
);

const ClosingSale = dynamic(
  () => (isPC ? import('../pc/closing-sale/ClosingSaleContainer') : import('../m/closing-sale/ClosingSaleContainer')),
  dynamicImportOption,
);

const Recipes = dynamic(
  () => (isPC ? import('../pc/recipes/MainRecipesContainer') : import('../m/recipes/MainRecipesContainer')),
  dynamicImportOption,
);

const InstagramReview = dynamic(
  () => (isPC ? import('../pc/instagram-review/InstagramReviewContainer') : import('../shared/Empty')),
  dynamicImportOption,
);

const GroupCollectionCircle = dynamic(
  () =>
    isPC
      ? import('../pc/collection-circle/GroupCollectionCircle')
      : import('../m/collection-circle/GroupCollectionCircle'),
  dynamicImportOption,
);

const RandomCollectionArticle = dynamic(
  () =>
    isPC
      ? import('../pc/collection-article/RandomCollectionArticle')
      : import('../m/collection-article/RandomCollectionArticle'),
  dynamicImportOption,
);

interface Props {
  section: MainSection<unknown>;
}

export default function MainSectionFactory({ section }: Props) {
  switch (section.type) {
    case 'MAIN_BANNERS':
      return <MainBanner section={section as MainSectionBanner} />;
    case 'MAIN_BANNER_CAROUSEL':
      return <MainBannerCarousel section={section as MainSectionBannerCarousel} />;
    case 'TODAY_RECOMMEND_PRODUCTS':
      return <TodayRecommendProducts section={section as MainTodayRecommendationSection} />;
    case 'RANDOM_COLLECTION':
    case 'MAB_COLLECTION':
      return <RandomCollection section={section as MainRandomCollectionSection} />;
    case 'LINE_BANNERS':
      return <LineBanner section={section as MainLineBannerSection} />;
    case 'SPECIAL_DEALS':
      return <SpecialDeals section={section as MainSpecialDealsSection} />;
    case 'MD_CHOICES':
      return <MdChoices section={section as MainMdChoicesSection} />;
    case 'CLOSING_SALE':
      return <ClosingSale section={section as MainClosingSaleSection} />;
    case 'RECIPES':
      return <Recipes section={section as MainRecipesSection} />;
    case 'INSTAGRAM_REVIEW':
      return <InstagramReview section={section as MainInstagramReviewSection} />;
    case 'RANDOM_COLLECTION_ARTICLE':
      return <RandomCollectionArticle section={section as MainRandomCollectionArticleSection} />;
    case 'GROUP_COLLECTION_CIRCLE':
      return <GroupCollectionCircle section={section as MainGroupCollectionCircleSection} />;
    default:
      return null;
  }
}
